/* ============================================================================
   M2 · Gallery. Thumbnail rail drives a crossfading stage.
   Progressive enhancement: with no JS the first slide is visible and the
   thumbnails are inert buttons, so the page still shows the product.
   ========================================================================= */
(function () {
  'use strict';

  document.querySelectorAll('[data-gallery]').forEach(function (root) {
    var slides = root.querySelectorAll('[data-slide]');
    var thumbs = root.querySelectorAll('[data-thumb]');
    if (!slides.length || !thumbs.length) return;

    function show(index) {
      slides.forEach(function (slide, i) {
        var on = i === index;
        slide.classList.toggle('is-active', on);
        // Hide inactive slides from assistive tech — they are still in flow
        // for the crossfade, so `aria-hidden` is what actually removes them.
        if (on) slide.removeAttribute('aria-hidden');
        else slide.setAttribute('aria-hidden', 'true');
      });
      thumbs.forEach(function (thumb, i) {
        var on = i === index;
        thumb.classList.toggle('is-active', on);
        thumb.setAttribute('aria-selected', on ? 'true' : 'false');
      });
    }

    thumbs.forEach(function (thumb, i) {
      thumb.addEventListener('click', function () { show(i); });
    });

    // Roving arrow-key navigation, per the tablist role on the rail.
    root.addEventListener('keydown', function (e) {
      if (e.key !== 'ArrowRight' && e.key !== 'ArrowLeft') return;
      var current = Array.prototype.indexOf.call(thumbs, document.activeElement);
      if (current === -1) return;
      e.preventDefault();
      var next = e.key === 'ArrowRight'
        ? (current + 1) % thumbs.length
        : (current - 1 + thumbs.length) % thumbs.length;
      thumbs[next].focus();
      show(next);
    });
  });
})();
